module.exports = __webpack_public_path__ + "img/president_message_ja.6935c21.jpg";